module.exports = __webpack_public_path__ + "static/media/cryptographic_tools_bitcoin-studio.988bacc4.jpg";